import React from 'react'
import Page from '../components/Page'
import Typography from '../components/Typography'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Form, FormFeedback, FormGroup, FormText, Input, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup } from 'reactstrap'
import { MdEdit, MdFormatListBulleted, MdFlag, MdLanguage, MdHome, MdAdd, MdCameraAlt, MdDone, MdClear, MdFilterList, MdCreate, MdDelete } from 'react-icons/md'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from '../utils/posAxios'
import PosMembershipTierForm from '../components/PosMembershipTierForm'
import PosMembershipPromoForm from '../components/PosMembershipPromoForm'
import PosScheduleModForm from '../components/PosScheduleModForm'
import PosScheduleSlotDayForm from '../components/PosScheduleSlotDayForm'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'

const member_column = [
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc',
  },

  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class PosMembershipMemberPage extends React.Component {
  access = StorageService.getSession('user_access')
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isGlobal: true,
      // isStore: this.props.history.location.state.isStore,
      //role: this.props.history.location.state.store_id ? this.access.store.find(x => x.store_id == this.props.history.location.state.store_id).role : '',
      isEdit: false,
      redirect: false,
      selectedId: '',
      selectedData: '',
      selectedType: '',
      name: '',
      member_type: '',
      accumulation: '',
      start_date: '',
      end_date: '',
      members: [],
      promoList: [],
      membership_id: '',
    }
  }

  componentDidMount() {
    this.getMembershipMember()
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  togglecustomerdetail =
    (action, id, type = null) =>
    () => {
      return this.setState({
        promoModal: !this.state.promoModal,
        isEdit: id != null && action == 'EDIT' ? true : false,
        selectedId: id,
        selectedType: type,
      })
    }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      tierModal: false,
      promoModal: false,
      promoConfirmModal: false,
      tierConfirmModal: false,
      storeConfirmModal: false,
      storeModal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getMembershipMember()
    }
  }

  getMembershipMember = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const membership_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      id: membership_id,
    }

    axios
      .post(url + ':3001/v1/membership/customerdetail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        for (let i of result.data.members) {
          i.Action = (
            <div className="ps-action-button">
              <Button className="theme-button theme-button-secondary" onClick={this.memberdetail(i.customer_id)}>
                Detail
              </Button>
              {/* <Button className="theme-button theme-button-primary-light" onClick={this.togglePromoConfirmModal(i.tier_name, i.applied_tier, i.id)}>
                Remove
              </Button> */}
            </div>
          )
        }

        this.setState({
          membership_id: membership_id,
          name: result.data.name,
          member_type: result.data.member_type,
          accumulation: result.data.accumulation,
          start_date: result.data.start_date,
          end_date: result.data.end_date,
          members: result.data.members,
        })
      })
      .catch(error => {
        alert(error)
      })
  }

  memberdetail = id => () => {
    this.props.history.push({
      pathname: `/posstore/membership/member/` + this.state.membership_id + `/detail/` + id,
    })
  }

  addMembershipTier = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const membership_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      membership_id: 3,
      tier_name: this.state.tier_name,
      entry_level: this.state.tier_entry_level,
      points_type: this.state.points_type,
      max_points: this.state.max_points,
      conversion_rate: this.state.conversion_rate,
      max_claim: this.state.max_claim,
      tier_unit: this.state.tier_unit,
      expiry_duration: this.state.expiry_duration,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Membership tier added successfully.',
          level: 'error',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
      })

      .catch(error => {
        alert(error)
      })
  }

  deleteTier = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      membership_id: this.state.membership_id,
      tier_id: this.state.selectedId,
      delete_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/tier/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Membership Tier deleted successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ tierConfirmModal: false })
        this.getMembershipDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    const member_data = {
      columns: member_column,
      rows: this.state.members,
    }

    return (
      <Page
        className="PosMembershipDetailPage"
        title="Member"
        breadcrumbs={[
          { name: 'Store', active: false, path: '/posstore' },
          { name: 'Member', active: true, path: '' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">Membership</CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={2}>
                    <Label>Membership Name</Label>
                    <p>{this.state.name}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Membership Type</Label>
                    <p>{this.state.member_type}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Accumulation</Label>
                    <p>{this.state.accumulation}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>Start Date</Label>
                    <p>{this.state.start_date}</p>
                  </Col>
                  <Col lg={2}>
                    <Label>End Date</Label>
                    <p>{this.state.end_date}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Member</Typography>
                    </div>
                  </Col>
                  <Col>
                    {/* <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.togglestore('ADD', null)}>
                        Add
                      </Button>
                    </div> */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <MDBDataTableV5 className="ps-order-table th-3" data={member_data} displayEntries={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* <Modal isOpen={this.state.storeConfirmModal} toggle={this.toggleStoreConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleStoreConfirmModal()}>Remove Membership Store</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to remove membership from this store?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleStoreConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.removeMembershipStore()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal> */}
      </Page>
    )
  }
}

export default PosMembershipMemberPage
